let selectedItem = function(idx) {
    for (const i in this.listTaks) {
        this.listTaks[i].selected = false;
    }
    this.listTaks[idx].selected = true;
    this.reEscribirLista();
};
export default selectedItem;
